const INITIAL_STATE = {
  address: {
    addresses: [],
    areAddressesLoading: false,
  },
  buyClosetItems: {
    selectedItemsIds: [],
    pendingClosetSales: {},
  },
  cart: {
    isCartModalOpen: false,
    pendingCart: {},
    usePurchaseCredit: true,
  },
  catalog: {
    filtersRecentlyModified: [],
  },
  customizableCloset: {
    currentCloset: {},
    anticipatedAddOnCount: 0,
    anticipatedAddOnError: "",
  },
  drawer: {
    open: false,
  },
  features: null,
  flashes: [],
  giftCardInfos: {},
  layoutBehaviors: {
    noNavbar: false,
    noFooter: false,
    onboarding: false,
    tourGuideAllowed: false,
    auth: false,
    noHead: false,
    routerTransition: false,
    context: null,
  },
  navigation: {
    catalog: {
      lastScrollY: 0,
    },
    home: {
      lastScrollY: 0,
    },
  },
  navSearch: {
    open: false,
  },
  referralRewards: {},
  reviewShort: {
    open: false,
    closet: {},
    finished: false,
  },
  tunnelSteps: {
    coupon: null,
    featuredPlan: null,
  },
  user: {
    currentUser: null,
    productsLiked: null,
    productsRented: null,
    closetHeaderLastVersion: "",
    userHeaderLastVersion: "",
  },
  userlists: {
    userLists: [{}, {}, {}],
    ongoingAction: "",
    product: {},
    userList: {},
  },
};

export default INITIAL_STATE;
